import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { PasswordInput, type PasswordInputProps } from '@interxfi/design-system/components/input/password-input/password-input';

export interface AppPasswordInputPropsWithLens extends Omit<PasswordInputProps, 'name' | 'value'> {
  shouldUnregister?: boolean;
  lens: Lens<string>;
}

export function AppPasswordInputWithLens({ onChange, shouldUnregister, lens, ...props }: AppPasswordInputPropsWithLens) {
  const { field, fieldState } = useController({ shouldUnregister, ...lens.interop() });
  const { onChange: fieldOnChange } = field;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      fieldOnChange(e.target.value);
      onChange?.(e);
    },
    [onChange, fieldOnChange],
  );

  return (
    <PasswordInput
      {...props}
      {...field}
      error={fieldState.error?.message}
      onChange={handleChange}
      touched={fieldState.isTouched}
      value={field.value || ''}
    />
  );
}
